import { render, staticRenderFns } from "./ItemQuote.vue?vue&type=template&id=270b847c&scoped=true&"
import script from "./ItemQuote.vue?vue&type=script&lang=js&"
export * from "./ItemQuote.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./ItemQuote.vue?vue&type=style&index=1&id=270b847c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b847c",
  null
  
)

export default component.exports